import React from 'react'
import { Field } from 'formik'
import { H3 } from '../ui/Typography.js'
import { Flex } from '../ui/Layout.js'
import Button from '../ui/Button.js'
import ModalContainer from '../ui/ModalContainer.js'
import { Input } from '../ui/Input.js'
import formikFormWrapper from '../formikFormWrapper.js'

const FormInput = formikFormWrapper(Input)

const CampaignNameModal = ({ isOpen, onClose, onSubmit, values, FormInputComponent = FormInput }) => {
  return (
    <ModalContainer interiorClose autoHeight p="24px" width="400px" isOpen={isOpen} setIsOpen={onClose}>
      <H3 width="100%">Give your campaign a name</H3>
      <Field mb="24px" maxLength={65} name="name" label="Campaign Name" dark component={FormInputComponent} />
      <Flex justifyContent="flex-end">
        <Button
          isDisabled={values.name && values.name.length < 5}
          onClick={() => {
            onClose()
            onSubmit()
          }}
          variant="black"
          label="Next"
        />
      </Flex>
    </ModalContainer>
  )
}

export default CampaignNameModal
